module.exports = __webpack_public_path__ + "school/img/ebooksPrimaryTwoBg.bd71d64a.jpg";